module.exports = __webpack_public_path__ + "img/ph.03c78e38.svg";